import { Flex } from '@radix-ui/themes';
import { EB } from 'components/layout/error-boundary';
import { ReactNode } from 'react';

export const CommonFlexColumn = (props: { children: ReactNode }) => (
  <EB>
    <Flex gap="2" direction="column" mb="4">
      {props.children}
    </Flex>
  </EB>
);
